export default __webpack_public_path__ + "static/media/Verification-Gif.4b177a4c.gif";